/**
 * @generated SignedSource<<2a23a378718230a4c86e83f207abaa39>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutReviewStepDeliveryView_deliveryOptions$data = ReadonlyArray<{
  readonly serviceId: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"PreQuoteTitle_shipmentQuote">;
  readonly " $fragmentType": "CheckoutReviewStepDeliveryView_deliveryOptions";
}>;
export type CheckoutReviewStepDeliveryView_deliveryOptions$key = ReadonlyArray<{
  readonly " $data"?: CheckoutReviewStepDeliveryView_deliveryOptions$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutReviewStepDeliveryView_deliveryOptions">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "CheckoutReviewStepDeliveryView_deliveryOptions",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PreQuoteTitle_shipmentQuote"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    }
  ],
  "type": "ShipmentQuote",
  "abstractKey": null
};

(node as any).hash = "691aebc4f094c137cc3555c70070b09c";

export default node;
